import React from 'react';
import BlurAmountView from 'design-system/BlurAmountView';
import Text from 'design-system/Text';
import { useAppSelector } from 'store/hooks';
function getColor(pct) {
    if (pct === 0)
        return { Secondary: true };
    if (pct > 0)
        return { Green: true };
    return { Red: true };
}
const FormattedAnnualReturn = ({ aar }) => {
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const { aarPct, howManyYears } = aar;
    const rounded = Math.round(aarPct * 100) / 100;
    return (<>
      <BlurAmountView enabled={scrambled}>
        <Text Numbers-16 {...getColor(rounded)}>
          {`${rounded > 0 ? '+' : ''}${rounded.toFixed(2)}%`}
        </Text>
      </BlurAmountView>
      <Text TextThin-14 Gray>{`${howManyYears} yr AAR`}</Text>
    </>);
};
export default React.memo(FormattedAnnualReturn);
